import React from "react";
import Logo from "../../assets/Circle-K-Logo.png";
import "./style.scss";
type Props = {
	children?: React.ReactNode;
};

const InternalError: React.FC<Props> = ({children}) => {
	return (
		<div className="error-wr">
			<img src={Logo} alt="logo" className="error-logo" />
			<h2>500 - Internal Server Error</h2>
		</div>
	);
};

export default InternalError;
